"use strict";

exports.__esModule = true;
exports.NotificationDetails = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Time = require("../../Time");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _styles = require("./styles");
var _NotificationPopupWidget = require("./NotificationPopupWidget");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var NotificationDetails = exports.NotificationDetails = function NotificationDetails(props) {
  var notification = props.notification,
    index = props.index,
    readNotification = props.readNotification;
  var time = _react["default"].useContext(_Time.TimeContext);
  var _useState = (0, _react.useState)(false),
    isOpen = _useState[0],
    setOpen = _useState[1];
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var handleOpen = function handleOpen() {
    readNotification(index);
    setOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.NotificationLine, {
    style: {
      backgroundColor: index % 2 ? "rgba(0,0,0,0.03)" : ""
    },
    key: notification.id,
    "data-testid": "NotificationLine-" + notification.id,
    onClick: function onClick() {
      readNotification(index);
      setOpen(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_styles.NotificationTitle, null, /*#__PURE__*/_react["default"].createElement(_styles.NotificationTitleText, null, notification.name), /*#__PURE__*/_react["default"].createElement(_styles.NewNotificationDotWrapper, {
    position: "static"
  }, notification.read ? null : /*#__PURE__*/_react["default"].createElement("circle", {
    "data-testid": "NotificationLine-" + notification.id + ".dot",
    cx: "5",
    cy: "5",
    r: "4",
    fill: "red"
  }))), /*#__PURE__*/_react["default"].createElement(_styles.NotificationMessage, null, /*#__PURE__*/_react["default"].createElement(_styles.NotificationMessageText, null, notification.message), /*#__PURE__*/_react["default"].createElement("small", {
    style: {
      opacity: "0.6"
    }
  }, (0, _momentTimezone["default"])(notification.timestamp).tz(time.timezone.name).format("YYYY-MM-DD")))), isOpen && /*#__PURE__*/_react["default"].createElement(_NotificationPopupWidget.NotificationPopupWidget, {
    notification: notification,
    onClickNoButton: handleClose,
    onClickYesButton: handleOpen
  }));
};